export const reduxKey = '@@DISCORD';
